import { pickRandomlyFromArray } from "src/arrays/pickRandomlyFromArray";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class SensorInputInstruction extends Instruction<"sensor-input"> {
  readonly type = "sensor-input";

  act(context: ProgramModel) {
    context.flux += pickRandomlyFromArray([1, 2, 3]);
  }
}
